import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';

const Hero = () => {
  return (
    <div className="relative bg-primary overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32 relative z-10">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
              <span className="block">Empowering Industries with</span>
              <span className="block text-accent">Expert Consulting Service</span>
            </h1>
            <p className="mt-3 text-base text-slate-300 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
              ECCI Software focuses on reliability, risk, and predictive solutions. Our team delivers personalized strategies that enable businesses to excel in an ever-changing world.
            </p>
            <div className="mt-8 sm:mt-10 sm:flex sm:justify-center lg:justify-start space-x-4">
              <div className="rounded-md shadow">
                <Link
                  to="/contact"
                  className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-primary bg-accent hover:bg-cyan-400 md:py-4 md:text-lg transition-colors"
                >
                  Get Started
                </Link>
              </div>
              <div className="mt-3 sm:mt-0 sm:ml-3">
                <Link
                  to="/services"
                  className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-accent bg-primary/50 border-accent hover:bg-primary/70 md:py-4 md:text-lg transition-colors"
                >
                  View Services
                </Link>
              </div>
            </div>
            
            <div className="mt-8 flex items-center space-x-6 text-sm text-slate-400">
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 text-accent mr-2" />
                <span>Industry-Leading Expertise</span>
              </div>
              <div className="flex items-center">
                <CheckCircle className="h-4 w-4 text-accent mr-2" />
                <span>Proven Track Record</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-12 lg:mt-0 relative"
          >
             {/* Abstract visual representation of data/network */}
             <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-700 bg-slate-800/50 backdrop-blur-sm p-8">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-slate-700/50 h-32 rounded-lg animate-pulse"></div>
                  <div className="bg-slate-700/50 h-32 rounded-lg"></div>
                  <div className="bg-slate-700/50 h-32 rounded-lg"></div>
                  <div className="bg-slate-700/50 h-32 rounded-lg animate-pulse delay-75"></div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center">
                    <p className="text-accent font-mono text-lg">System Reliability</p>
                    <div className="h-1 w-24 bg-accent mx-auto mt-2 rounded-full"></div>
                  </div>
                </div>
             </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
